import React, { Component } from 'react';
import moment from 'moment';
import Collapsible from 'react-collapsible';
import Countdown, { zeroPad } from 'react-countdown-now';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import packageJson from '../../../package.json';
import api from '../../axios-local-api';
import Confirm from '../../components/UI/Confirm/Confirm';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import ClaimPod from '../ClaimPod/ClaimPod';
import Counter from '../../components/Counter';
import classes from './PodTroubleshooting.css';

export class PodTroubleshooting extends Component {
  constructor(props) {
    super(props);
    this.rebootHandler = this.rebootHandler.bind(this);
    this.state = {
      success: false,
      error: false,
      action: null,
      result: null,
      confirmModal: false,
      reclaimModal: false,
      upArrowsM: false,
    };
  }

  componentDidMount() {}
  componentWillUpdate() {}
  componentDidUpdate() {}
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.props.onResetSettingsErrorSuccess();
  };
  confirmModalConfirmHandler = () => {
    if (this.state.action === 'Reboot the Extender?') {
      this.props.onRebootPod(this.props.selectedEquipment.podId);
    }
    this.closeModal();
  };
  confirmModalCancelHandler = () => {
    this.setState({ confirmModal: false });
  };
  closeModal = () => {
    this.setState({ confirmModal: false });
  };
  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };
  rebootHandler() {
    this.onOpenModal(
      'This will interrupt connectivity for a few minutes.',
      'Reboot the Extender?'
    );
  }

  handleReclaimPod = () => {
    let props = this.props;
    //console.log("handle reclaim Pod", props);
    let reclaimPodPromise = new Promise(function (resolve, reject) {
      let result = props.onReclaimPod(props.selectedEquipment.podId);
      //console.log("result", result);
      resolve();
    });
    reclaimPodPromise.then(() => {
      //console.log("checking change pod success", props);
    });
    this.setState({
      reclaimModal: false,
    });
  };

  handleReclaimModalCancel = () => {
    this.setState({
      reclaimModal: false,
    });
  };

  reclaimHandler = () => {
    this.setState({
      reclaimModal: true,
    });
  };
  closeHandlerM = () => {
    this.setState({
      upArrowsM: false,
    });
  };

  openHandlerM = () => {
    this.setState({
      upArrowsM: true,
    });
  };

  render() {
    //console.log("PodTroubleshooting.render", this.props);
    if (this.props.error && !this.state.error) {
      this.setState({ error: true });
      this.props.onResetSettingsErrorSuccess();
    }
    if (this.props.success && !this.state.success) {
      this.setState({ success: true });
      this.props.onResetSettingsErrorSuccess();
    }
    var disableFirmwareUpgrade = this.props.firmwareUpdate
      ? !this.props.firmwareUpdate.upgradeRecommended
      : true;
    var firmwareUpgradeTitle;
    if (this.props.firmwareUpdate) {
      firmwareUpgradeTitle = this.props.firmwareUpdate.upgradeRecommended
        ? ''
        : 'There is no Firmware Upgrade Recommended';
    } else {
      firmwareUpgradeTitle = '';
    }
    //  console.log("disableFirmwareUpgrade", disableFirmwareUpgrade, "firmwareUpgradeTitle", firmwareUpgradeTitle);
    let podTroubleshootingContent;

    if (this.props.settingsLoading) {
      podTroubleshootingContent = <Spinner />;
    } else if (
      (this.props.checkingWan ||
        (this.props.podTimer &&
          this.props.rebootPodId === this.props.selectedEquipment.podId)) &&
      this.props.timerStart
    ) {
      podTroubleshootingContent = (
        <div id = 'PodRebootTxt' style={{ padding: '20px' }}>
          The Extender is restarting... estimated wait time is 2-10 minutes, elapsed
          time{' '}
          <Counter startDate={this.props.timerStart} />
        </div>
      );
    } else if (!this.props.realSettings && !this.props.realWan) {
      podTroubleshootingContent = (
        <div style={{ padding: '20px' }}>
          Extender Troubleshooting not available. Try to log in again form Gateway.
        </div>
      );
    } else if (!this.props.selectedEquipment.podConnectionState) {
      podTroubleshootingContent = (
        <div style={{ padding: '20px' }}>
          This Extender is disconnected. Please ask the customer to reconnect inorder
          to perform Extender troubleshooting tasks.
        </div>
      );
    } else if (
      this.props.selectedEquipment.podConnectionState !== 'connected'
    ) {
      podTroubleshootingContent = (
        <Box>
          <div className={classes.Separator} />
          <div className={classes.TitleArea}>
            <div>Extender Reclaim</div>
            <button
              className={classes.ActionButton}
              id="PodReclaim"
              onClick={this.reclaimHandler}
              disabled={
                this.props.firmwareDisplayUpdateSpinner  ||
                this.props.optimizeRouterDisplayUpdateSpinner
              }
              title={
                this.props.firmwareDisplayUpdateSpinner
                ? 'Please wait until Firmware Update has completed' :
                this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : ''
             }
            >
              Reclaim
            </button>
          </div>
        </Box>
      );
    } else {
      podTroubleshootingContent = (
        <Box>
          <div className={classes.TitleArea}>
            <div>Extender Reboot</div>
            <button
              className={classes.ActionButton}
              id="RebootButton"
              title={
                this.props.firmwareDisplayUpdateSpinner
                ? 'Please wait until Firmware Update has completed' :
                this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : ''

              }
              onClick={this.rebootHandler}
              disabled={
                (this.props.checkingWan && this.props.timerStart) ||
                (this.props.wan?.loaded && this.props.wan?.realWan?.connectionState === 'disconnected') ||
                this.props.firmwareDisplayUpdateSpinner ||
                this.props.isSteering ||
                this.props.optimizeRouterDisplayUpdateSpinner }
            >
              Reboot
            </button>
          </div>
          <div className={classes.Separator} />
          <div className={classes.TitleArea}>
            <div>Extender Reclaim</div>
            <button
              className={classes.ActionButton}
              id="PodReclaim"
              onClick={this.reclaimHandler}
              disabled={
                this.props.firmwareDisplayUpdateSpinner  ||
                this.props.optimizeRouterDisplayUpdateSpinner
              }
              title={
                this.props.firmwareDisplayUpdateSpinner
                ? 'Please wait until Firmware Update has completed' :
                this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : ''
             }
            >
              Reclaim
            </button>
          </div>
        </Box>
      );
    }

    let arrowM = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrowsM) {
      arrowM = (
        <MdKeyboardArrowUp aria-label="arrow up" color={'gray'} size={'30px'} />
      );
    }

    return (
      <Box>
        <div className={classes.PodTroubleshooting}>
          <div className={classes.showDesktop}>
            <div className={classes.TitleArea}>
              <h3 id = 'podTroubleshootingTxt' style={{ paddingRight: 20 }}>Extender Troubleshooting</h3>
            </div>
            <div className={classes.Separator} />
            {podTroubleshootingContent}
          </div>
          <div
            className={[classes.showMobile].join(' ')}
            style={{ borderRadius: '5px 5px 0px 0px' }}
          >
            <Collapsible
              transitionTime={100}
              onOpening={() => {
                this.openHandlerM();
              }}
              onClosing={() => {
                this.closeHandlerM();
              }}
              trigger={
                <Box>
                  <div>
                    <div className={classes.MobileTitleArea}>
                      <div className={classes.Header}>
                        <h3>Extender Troubleshooting</h3>
                      </div>
                      <button className={classes.OpenCloseButton}>
                        {arrowM}
                      </button>
                    </div>
                  </div>
                </Box>
              }
            >
              <div>
                {' '}
                <div className={classes.Separator} />
                {podTroubleshootingContent}
              </div>
            </Collapsible>
          </div>
        </div>
        <Modal show={this.state.confirmModal} modalClosed={this.closeModal}>
          <Confirm
            id={'PodTroubleshootingConfirm'}
            action={this.state.action}
            result={this.state.result}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
            deviceGroupConfirmation
          />
        </Modal>
        <Modal show={this.state.reclaimModal} modalClosed={this.closeModal}>
          <ClaimPod
            podTitle="Reclaim EXTENDER"
            podMessage="Are you sure you want to reclaim this Extender?"
            podBtnText="Reclaim"
            onCancel={this.handleReclaimModalCancel}
            onSuccess={this.handleReclaimPod}
            reclaim={true}
          ></ClaimPod>
        </Modal>

        <Modal
          show={this.state.error}
          modalClosed={this.successErrorResetHandler}
        >
          <Error id={'PodTroubleshootingError'} />
        </Modal>
        <Modal
          show={this.state.success}
          modalClosed={this.successErrorResetHandler}
        >
          <Success id={'PodTroubleshootingSuccess'} />
        </Modal>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settingsLoading: state.settings.loading,
    settingsLoaded: state.settings.loaded,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    realSettings: state.settings.realSettings,
    firmwareUpdate: state.settings.firmwareUpdate,
    firmwareUpdateLoading: state.settings.firmwareUpdateLoading,
    firmwareUpdateLoaded: state.settings.firmwareUpdateLoaded,
    firmwareUpdateError: state.settings.firmwareUpdateError,
    realWan: state.wan.realWan,
    realDevices: state.devices.realDevices,
    devicesByEquipment: state.devices.devicesByEquipment,
    checkingWan: state.wan.checkingWan,
    podTimer: state.wan.podTimer,
    rebootPodId: state.wan.rebootPodId,
    timerStart: state.wan.timerStart,
    selectedEquipment: state.equipment.selectedEquipment,
    success: state.settings.success,
    error: state.settings.error,
    isSteering: state.devices.realDevices.some(d => d.steering && d.steering.forced
      && d.steering.forced.expiresAt && moment().isBefore(moment(d.steering.forced.expiresAt))),
    firmwareDisplayUpdateSpinner: state.settings.firmwareDisplayUpdateSpinner,
    wan: state.wan,
    optimizeRouterDisplayUpdateSpinner: state.settings.optimizeRouterDisplayUpdateSpinner
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRebootPod: (pSerial) => dispatch(actions.rebootPod(pSerial)),
    onResetSettingsErrorSuccess: () =>
      dispatch(actions.resetSettingsErrorSuccess()),
    onReclaimPod: (serialNumber) => dispatch(actions.reclaimPod(serialNumber)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(PodTroubleshooting, api));
